import React, {Suspense} from 'react';
import {Route} from "react-router-dom";
import {Loading} from "../../components";


export const SuperAdminRoutes = (configurationRole, userCf) => (
    <>
        {configurationRole.SUPER_ADMIN.LINKS
            .filter(link => !link.RESTRICTED_TO_CF || link.RESTRICTED_TO_CF.includes((userCf || '').toUpperCase()))
            .map(link =>
            <Route path={`${configurationRole.SUPER_ADMIN.CONTEXT_ROUTES}${link.LINK}`}
                   key={link.LINK.split('/')[1]}
                   name={link.LINK.split('/')[1]}
                   element={
                       <Suspense fallback={<Loading messaggio='Recupero dati...'/>}>
                           <link.LAZY_COMPONENT/>
                       </Suspense>
                   }/>
        )}

        {configurationRole.SUPER_ADMIN.ROUTES.map(route =>
            <Route path={`${configurationRole.SUPER_ADMIN.CONTEXT_ROUTES}${route.LINK}`}
                   key={route.LINK}
                   name={route.LINK}
                   element={
                       <Suspense fallback={<Loading messaggio='Recupero dati...'/>}>
                           <route.LAZY_COMPONENT/>
                       </Suspense>
                   }/>
        )}

    </>

);
